module.exports = "/_next/static/images/customer-review-magdalena@2x-min-4f0bcdba27a156fccd7123cacf436d2f.png";